// NFKC (composed)             // (decomposed)
export const EtherSymbol = "\u039e"; // "\uD835\uDF63";
//# sourceMappingURL=strings.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ethersproject/constants/lib.esm/strings.js
// module id = 100
// module chunks = 0